import { isDev } from "@memorang/constants/urls";
import { baseNextjsUrl } from "@memorang/constants/urls";

export const urls = {
	core: "https://memorang.com",
	dev: "http://localhost:8081",
};

export const ENDPOINT_FEEDBACK = `${baseNextjsUrl}/api/v2/ai/submissions`;
export const ENDPOINT_EXAM_CONTEXT = `${baseNextjsUrl}/api/v2/ai/exam-context`;
export const ENDPOINT_HINT = `${baseNextjsUrl}/api/v2/ai/hint`;
export const ENDPOINT_CACHE = `${baseNextjsUrl}/api/v2/cache`;
export const API_BASE_URL = isDev
	? "https://beta.api.memorang.io"
	: "https://prod.api.memorang.io";

export const JBJS_FULL_ARTICLE_URL =
	"https://www.jbjs.org/reader.php?rsuite_id=";
export const ENDPOINT_ASSESSOR = `${baseNextjsUrl}/api/v2/ai/graphs/assessor`;
